<template>
  <div class="wrapper padding-sm bg-white">
    <div class="flex align-start justify-between margin-bottom">
      <h3 class="page-title line-height">分支机构聘书</h3>
    </div>

      <el-image v-if="certificate" :src="imgUrl + certificate" alt="" class="certificate">
          <div slot="error">
              <el-empty description="暂无聘书"></el-empty>
          </div>
      </el-image>
  </div>
</template>

<script>
import {getFhPinShu} from "@/api/branch";
import {IMAGE_PATH} from "@/config";

export default {
  name: "certificate",
  data() {
    return {
      certificate: '',
      noCertificate:false,
    }
  },

  created() {
    this.$emit('setIndex', [8, 0], '分支机构聘书')
    this.getCertificate()

  },
  computed: {
    imgUrl() {
      return IMAGE_PATH
    },
  },
  components: {},
  methods: {
    async getCertificate() {
      let _data = await getFhPinShu()
      if (_data.status === 200) {
        this.certificate = _data.data + '?v=' + new Date().getTime()
      }else {
        this.noCertificate = true
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
  .certificate{
    width: 100%;
  }
</style>